import React from "react";
import { Form } from "antd";
import { getDateOfBirth } from "../../../../../NPA/Pages/Step1Setup/Components/UtilFunctions";
import Calendar from '../../../../../../CommonComponents/Calendar/Calendar';
import {
  WrapLabel,
  LabelWrapper,
  DatePickerWrapper,
  InputMargin,
  DatePickerInput,
  ErrorMsgWrap
} from "../../styles";

function DatePickerComponent(props) {
  const { labelValue, value, dateChange, disableDate, errorLabel=false, placeholder, id , ariaLabel} = props;

  return (
    <WrapLabel>
      <InputMargin marginBottom="30px">
        <Form.Item
          colon={false}
          label={<LabelWrapper for={id}>{labelValue}</LabelWrapper>}
        >
          <DatePickerWrapper height="22px">
            <Calendar
              id={id ? id: ""}
              ariaLabel={ariaLabel}
              placeHolder={placeholder}
              format="MM/DD/YYYY"
              disabledDate={disableDate}
              value={value && getDateOfBirth(value)}
              onChange={dateChange}
            />
             {errorLabel &&
              <ErrorMsgWrap>
                {errorLabel}
              </ErrorMsgWrap>}
          </DatePickerWrapper>
        </Form.Item>
      </InputMargin>
    </WrapLabel>
  );
}

export default DatePickerComponent;